<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title=" Senarai Akaun Belum Terima Hutang-Hutang Lain">
            <w-form ref="dform" @validate="search">
                
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <z-lookup 
                            label="Bulan"
                            url="bulanlookupstatic"
                            :sort="false" :cache="false" v-model="cari.bulan" />
                        <z-lookup v-if="show_jabatan == true"
                            label="Jabatan"
                            :url="service_kutipan + 'lookup/jabatan_user2'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.jabatan_id"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <!-- <w-input 
                            v-model="cari.tahun"
                            label="Tahun"
                            type="number"
                        /> -->
                        <z-lookup 
                        label="Tahun"
                        name="tahun"
                        url="admin.yearlookup"
                        :sort="false"
                        :cache="false"
                        
                        v-model="cari.tahun"
                        />
                    </div>
                    
                </w-flex>

            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="janaDialog()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Jana
                    </w-button>
                </div>
            </w-flex>
            <center v-if="loading == true"><w-progress class="ma1" circle></w-progress></center>
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>Bil</td>
                                <td>Butiran/Perkara</td>
                                <td>ABT (Selepas Pelarasan dan Terimaan)<br>(1)<br>(RM)</td>
                                <td>Amaun Hapus Kira Yang Diluluskan<br>(2)<br>(RM)</td>
                                <td>Jumlah Bersih ABT<br>(3) = (1) - (2)<br>(RM)</td>
                                <td>Jumlah Penjejasan Nilai Terkumpul<br>(4)<br>(RM)</td>
                                <td>Jumlah Tunggakan<br>(5)<br>(RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>HINGGA 6 BULAN</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>> 6 BULAN - 12 BULAN</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>> 12 BULAN - 36 BULAN</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>> 36 BULAN - 72 BULAN</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>> 72 BULAN - 120 BULAN</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>> 120 BULAN</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>JUMLAH</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                                <td style="text-align: right">0.00</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </w-flex>
        

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>

            <w-dialog
                v-model="dialog.show"
                title="Sila pilih janaan Anda"
                persistent
                :width="550">

            <template #actions>
                <div class="spacer" />
                <w-button
                class="mr2"
                @click="janaDb()"
                :loading="readingfile"
                bg-color="error">
                Janaan Pertama
                </w-button>
                <w-button
                @click="janaCache()"
                bg-color="success">
                Jana Semula
                </w-button>&nbsp;&nbsp;
                <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
            </template>
            </w-dialog>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
    auth: [Array, Object],
    show_jabatan: [Array, Object, String],
  },
  data() {
    return {
        resourceurl: this.service_laporan+'kutipan/laporan/dummy',
        reload: true,
        loading: false,
        readingfile: false,
        disabled: false,
        status: [
            {
                value: 1,
                label: 'Aktif',
            },
            {
                value: 2,
                label: 'Tidak Aktif',
            },
        ],
        dialog: {
            show: false,
        },
        crumbs: [
            { label: 'iHasil', route: '/' },
            { label: 'Tunggakan Hasil', route: '/tunggakanhasil' },
            { label: 'Akaun Belum Terima', route: '/tunggakanhasil/akaunbelumterima' },
            { label: 'ABT 1c', route: '/akaun_belum_terima/abt_1c' },
          ],
          cari : {bulan: '', tahun: '', jabatan_id: ''},
          cache: true,
          }
  },
  methods: {

    search() {
        this.getDataQuery();
    //   this.$inertia.visit(window.route('akaun_belum_terima.abt_1b')+'?bulan='+this.cari.bulan+'&tahun='+this.cari.tahun, {preserveScroll:true})
    },
    janaDialog(){
        this.readingfile = true;
        this.disabled = true;
        axios.get(
            this.service_laporan + "kutipan/laporan/check_file_cache?user_id=" + this.auth.user.id +
                "&bulan=" + this.cari.bulan +
                "&tahun=" + this.cari.tahun +
                "&jabatan_id=" + this.cari.jabatan_id
                
        ).then((e)=>{
            if(e.data){
                // console.log('found!')
                this.disabled = true;
            } else {
                // console.log('not found!')
                this.disabled = false;
            }
            this.readingfile = false;
        })
        this.dialog.show = true
    },
    janaDb(){
        this.dialog.show = false
        this.cache = false
        this.$refs.dform.validate()
    },
    janaCache(){
        this.dialog.show = false
        this.cache = true
        this.$refs.dform.validate()
    },
    reset(){
      this.cari = {bulan: '', tahun: '', jabatan_id: ''}
      this.search()
    },
    cetak() {
            window.open(this.service_laporan+'kutipan/laporan/abt1a?cetak=true&user_id='+this.auth.user.id+
            "&bulan=" + this.cari.bulan + '&from=abt1c' +
            "&tahun=" + this.cari.tahun +
            "&jabatan_id=" + this.cari.jabatan_id + '&static=true' + '&cache=' + this.cache,'_blank');
        },
    async getDataQuery() {
        this.loading = true;
        // const resp = await axios.get(
        //     this.service_laporan + "kutipan/laporan/cukai_akaun_belum_terima?user_id=" + this.auth.user.id +
        //         "&bulan=" + this.cari.bulan +
        //         "&tahun=" + this.cari.tahun +
        //         "&jabatan_id=" + this.cari.jabatan_id + '&static=true' + '&cache=' + this.cache
        // );
        // this.table = resp.data;
        this.loading = false;
    },
  },
  watch: {
  },
  mounted() {
    // override default setting
    // this.getData();
    this.dialog.width = 900
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari.bulan == 'undefined'){this.cari.bulan = ''}
    if(this.cari.tahun == 'undefined'){this.cari.tahun = ''}
    if(this.cari.jabatan_id == 'undefined'){this.cari.jabatan_id = ''}
    if(this.cari.from_abt){
        this.getDataQuery()
    }
    // console.log(this.auth.user);
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>